import React from 'react';
import PropTypes from 'prop-types';


import * as styleUtils from '../../../../utils/styleUtils';

import styles from './Checkbox.scss';


function Checkbox({isChecked, isDisabled, id, isSmall, name, onChange, value}) {

    return (
        <input
            className={styleUtils.toClasses(styles.checkbox, isSmall && styles.small)}
            checked={isChecked}
            disabled={isDisabled}
            id={id}
            name={name}
            onChange={event => onChange(event.target.checked)}
            type={'checkbox'}
            value={value}
        />
    );
}


Checkbox.propTypes = {
    id: PropTypes.string,
    isChecked: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isSmall: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
};

Checkbox.defaultProps = {
    isChecked: false,
    isDisabled: false,
    isSmall: false,
    name: 'checkbox',
    value: 'on'
};


export default Checkbox;
